// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a2204acc","422":"6df92514","455":"f373fcdb"}[chunkId] + ".chunk.js";
};